"use client";

import { MapPin } from "lucide-react";
import { useRegionStore, useLocationStore } from "@/store/index";
import { cn } from "@/lib/util/utils";

interface LocationSelectorProps {
  className?: string;
  variant?: "default" | "compact";
}

export function LocationSelector({
  className,
  variant = "default",
}: LocationSelectorProps) {
  const { region, countryCode, setRegionModalOpen } = useRegionStore();
  const { provinceName, municipality } = useLocationStore();

  const currentCountry = region?.countries?.find(
    (c) => c.iso_2 === countryCode
  );
  const countryDisplay =
    currentCountry?.display_name ||
    currentCountry?.iso_2?.toUpperCase() ||
    region?.name ||
    "";

  let display = "Seleccionar ubicación";
  if (countryDisplay && provinceName) {
    display = `${countryDisplay} — ${provinceName}`;
    if (countryCode?.toLowerCase() === "cu" && municipality) {
      display += `, ${municipality}`;
    }
  } else if (countryDisplay) {
    display = countryDisplay;
  }

  const handleClick = () => setRegionModalOpen(true);

  if (variant === "compact") {
    return (
      <button
        onClick={handleClick}
        className={cn(
          "flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-sm font-medium transition-colors hover:bg-white/50",
          className
        )}
      >
        <MapPin className="h-4 w-4" />
        <span className="hidden sm:inline">{display}</span>
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      className={cn(
        "flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors hover:bg-white/50",
        className
      )}
    >
      <MapPin className="text-green-main h-5 w-5" />
      <div className="flex flex-col items-start">
        <span className="text-xs text-gray-500">Ubicación</span>
        <span className="font-medium">{display}</span>
      </div>
    </button>
  );
}
